const o = "_text_1ugi1_1", r = "_underlined_1ugi1_38", _ = "_ellipsis_1ugi1_41", l = {
  text: o,
  "color-primary": "_color-primary_1ugi1_14",
  "color-primary-brand": "_color-primary-brand_1ugi1_17",
  "color-secondary": "_color-secondary_1ugi1_20",
  "color-gray": "_color-gray_1ugi1_23",
  "color-success": "_color-success_1ugi1_26",
  "color-error": "_color-error_1ugi1_29",
  "color-disabled": "_color-disabled_1ugi1_32",
  "color-white": "_color-white_1ugi1_35",
  underlined: r,
  ellipsis: _
};
export {
  l as default,
  _ as ellipsis,
  o as text,
  r as underlined
};
//# sourceMappingURL=index.es5508.js.map
